import { console_api } from '../http/consoleClient';
import { ConsoleUser } from 'types/console/users.types';

export const consoleUsersApi = {
  // `signal` lets the caller cancel a profile request it no longer needs
  // (e.g. the signed-in person changed or signed out).
  getMe: async (email: string, signal?: AbortSignal): Promise<ConsoleUser> => {
    const response = await console_api.get<ConsoleUser>('/console/me', { params: { email }, signal });
    return response.data;
  },

  listUsers: async (requesterEmail: string): Promise<ConsoleUser[]> => {
    const response = await console_api.get<{ users: ConsoleUser[] }>('/console/users', {
      params: { requester_email: requesterEmail },
    });
    return response.data.users;
  },

  createUser: async (payload: {
    requester_email: string;
    user_email: string;
    user_first_name?: string;
    user_last_name?: string;
    user_role: 'admin' | 'business_analyst' | 'tableau_admin';
    is_active: boolean;
  }): Promise<ConsoleUser> => {
    const response = await console_api.post<ConsoleUser>('/console/users', payload);
    return response.data;
  },

  setUserStatus: async (payload: {
    requester_email: string;
    user_email: string;
    is_active: boolean;
  }): Promise<ConsoleUser> => {
    const response = await console_api.patch<ConsoleUser>(
      `/console/users/${encodeURIComponent(payload.requester_email)}/status`,
      {
        user_email: payload.user_email,
        is_active: payload.is_active,
      }
    );
    return response.data;
  },
};
